import React from 'react'
import RefundPolicyHeader from '../components/Common/RefundPolicyHeader'

const PrivacyPolicy = () => {
  return (
    <RefundPolicyHeader Desc='Thank you for signing up with Swiftuni.'/>
  )
}

export default PrivacyPolicy